import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=69552d2b&scoped=true"
import script from "./VersionInfo.vue?vue&type=script&lang=js"
export * from "./VersionInfo.vue?vue&type=script&lang=js"
import style0 from "./VersionInfo.vue?vue&type=style&index=0&id=69552d2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69552d2b",
  null
  
)

export default component.exports